import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';

import * as firebase from 'firebase/app'

export class SessionInfo {
  status: number;
  id: number;
}


@Component({
  selector: 'app-teacher-config-view',
  templateUrl: './teacher-config-view.component.html',
  styleUrls: ['./teacher-config-view.component.css']
})
export class TeacherConfigViewComponent implements OnInit {

	// @Output() saveSession = new EventEmitter();
	@Output() setTrack = new EventEmitter();

	sessions: any[];
	session: any[];

	oldCode = false;
	codePath = false;
	usedCode = false;
	title = "VÄLKOMMEN LÄRARE!"
	description = "Skapa en kod för att koppla ihop dina elever och dig i en lektion.";
	code = "" // Den valda koden
	codeSelected = false; // Visar spår när man valt kod
	sessionCode = "" // Visar koden i botten på sidan
	connected = 0;
	totalConnects = 0;
	totalDisConnects = 0;


	



	onSearchChange(event){
		this.code = event;
	}

	selectedCodePath(event){
		this.codePath = true;
		if (event == 1)
			this.usedCode = false;
		else
			this.usedCode = true;
	}

	// Läraren sparar en kod som skickas till DB
	AcceptCode(event){
		this.usedCode = false;
		if (event == 1) {
			for(let row of this.sessions){

				if (this.code == row){
					this.codeSelected = true;
					this.service.sessionCode = this.code;
					this.service.sessionId = this.code;
					this.sessionCode = this.code;
					this.db.list('/Session-'+this.service.sessionId + "/action").remove();
					this.db.list('/Session-'+this.service.sessionId + "/question").remove();
					this.db.list('/Session-'+this.service.sessionId + "/track").remove();
					this.db.list('/Session-'+this.service.sessionId + "/connected").remove();
					this.db.list('/Session-'+this.service.sessionId + "/disconnected").remove();
				};
			}

		}
		else{

		this.service.sessionCode = this.code;
		this.service.sessionId = this.code;
		this.sessionCode = this.code;

		this.codeSelected = true;

		this.db.list('/Sessions').push(this.code);
		this.db.list('Session-'+ this.code + "/code").push(this.code);
		this.title = "VÄLJ TEMA";
		}




		//Läser av hur många som är kopplade till sessionen

		 this.db.list('/Session-'+ this.code + "/connected").valueChanges().subscribe((session: any) => {
		    this.session = session;
		    this.totalConnects = session.length;
		     this.calculateConnects();
		  });

		 this.db.list('/Session-'+ this.service.sessionCode + "/disconnected").valueChanges().subscribe((disconnects: any) => {
		    this.totalDisConnects = disconnects.length;
		    this.calculateConnects();
		  });
	}

	calculateConnects(){
		this.connected = this.totalConnects - this.totalDisConnects;
	}


	//När läraren väljer ett av de tre spåren
	SelectTrack(trackId){

    firebase.analytics().logEvent("Teacher started session",{
      track: trackId
    });


  	if (this.service.saveCode) {
  		this.code = this.service.sessionCode;
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/question").remove();
		this.db.list('/Session-'+this.service.sessionId + "/track").remove();
		this.db.list('/Session-'+this.service.sessionId + "/connected").remove();
		this.db.list('/Session-'+this.service.sessionId + "/disconnected").remove();
  	}
		//Meddela att läraren är klar med inställningar så vi kan gå vidare till nästa vy
		this.setTrack.emit(event);
		//Spara spår och sätt fråga till nummer 1
	    this.service.selectedTrack = trackId;
    	this.service.currentQuestion = 1;
		//Spara spår och fråga i FB
		this.db.list('/Session-'+this.code + "/track").push(trackId);
		this.db.list('/Session-'+this.code + "/action").push("activate");
		this.db.list('/Session-'+this.code + "/question").push("1");

	}

  constructor(
  	private service: ApiCallerService,
  	private db: AngularFireDatabase) { }

  ngOnInit() {


  	if (this.service.saveCode) {
  		this.codeSelected = true;
  		this.db.list('/Session-'+this.service.sessionId + "/connected").remove();
  	}

    this.db.list('/Sessions').valueChanges().subscribe((value: any) => {
      this.sessions = value;

    });


   var exists = false;
    this.code = Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1) + "" + Math.floor(Math.random() * 9 + 1);
    this.sessionCode = this.code;
    this.db.list('/Sessions').valueChanges().subscribe((value: any) => {
      for(let row of value){
          if (row == this.code) {
            exists = true;
          }
      }
    });



  }

}
